import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import classNames from 'classnames';
import Marquee from 'react-fast-marquee';
import { meta } from '../../../meta';

export function Carousel({ children }: PropsWithChildren) {
  const { carouselPauseOnHover, carouselSpeed, displayDeactivation } =
    useSettings();
  const marqueeDirection = document.dir === 'rtl' ? 'right' : 'left';

  return (
    <Component>
      <StyledMarquee
        direction={marqueeDirection}
        pauseOnHover={carouselPauseOnHover}
        speed={displayDeactivation ? 0 : carouselSpeed / 50}
        autoFill
      >
        <Inner>{children}</Inner>
      </StyledMarquee>
    </Component>
  );
}

const Component = styled.div.attrs({
  className: classNames(
    `${meta.prefix}-carousel-component`,
    'es-layout',
    'es-layout-carousel'
  )
})`
  width: 100%;
  max-width: 100vw;
  backface-visibility: hidden;
  white-space: nowrap;
`;

const Inner = styled.div.attrs({
  className: classNames(
    `${meta.prefix}-carousel-inner`,
    'es-layout-carousel-content'
  )
})`
  display: inline-flex;
`;

const StyledMarquee = styled(Marquee).attrs({
  className: 'es-layout-carousel-wrapper'
})`
  flex-direction: ${({ direction }) =>
    direction === 'left' ? 'row' : 'row-reverse'};
`;
